const getThemeColors = (theme) => {
    switch (theme) {
      case "dark":
        return { theme: "#F9F5ED", background: "#16140E" };
      case "eclipse":
        return { theme: "#16140E", background: "#FFFFDB" };
      case "light":
        return { theme: "#16140E", background: "#fff" };
      default:
        return { theme: "#16140E", background: "#fff" };
    }
  };
  
  export default getThemeColors;
  